<mat-radio-group name="{{ groupName }}" [formControl]="formControl">
  <ng-container *ngFor="let item of items let i = index;">
    <div class="picker-list__item">
      <div class="picker-item" [ngClass]="{'is-disabled': isCheckMinMaxRestrictions && !item.restrictions.maxQuantity}">
        <div class="picker-item__label h4">{{ item.name }}</div>
        <div class="picker-item__right">
          <ng-container *ngIf="{price: item.prices | outletPrice | async} as data">
            <div class="picker-item__price" *ngIf="isNotFree(item, data.price)">
              <app-price [price]="data.price!"></app-price>
            </div>
            <div class="picker-item__price is-free" *ngIf="!isNotFree(item, data.price)">
              <span>
                +<app-price [price]="0"></app-price>
              </span>
            </div>
            <div class="picker-item__price is-free" *ngIf="item.balance === 0">
              <span i18n="@@NotAvailable">Not available</span>
            </div>
          </ng-container>
          <div class="picker-item__ctrl" *ngIf="item.balance !== 0">
            <mat-radio-button (change)="onChangeCount(item)" [value]="item.sku" [disabled]="isCheckMinMaxRestrictions && !item.restrictions.maxQuantity"></mat-radio-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</mat-radio-group>

